export default __webpack_public_path__ + "static/media/img1.e145f3c2.png";